<h2 mat-dialog-title>{{'importnewtemplateDialog.confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <ng-container *ngIf="data.reportTemplate">
    <p>{{'importnewtemplateDialog.RTName' | translate}}<p>
      <b>{{ data.reportTemplate.name }}</b>
  </ng-container>
  <p>{{'importnewtemplateDialog.suretoImport' | translate}}</p>
  <mat-list>
    <mat-list-item>
      <p>{{ data.filename }}</p>
    </mat-list-item>
  </mat-list>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button color="primary" mat-dialog-close>{{'importnewtemplateDialog.no' | translate}}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{'importnewtemplateDialog.yes' | translate}}</button>
  </mat-dialog-actions>
</div>
